import type { ComparisonAccount } from './comparisonTypes';
import {
  comparisonLoadingMessage,
  isComparisonDataLoading,
} from './comparisonLoading';

const ComparisonLoadingBanner = ({
  accounts,
}: {
  accounts: ComparisonAccount[];
}) => {
  if (!isComparisonDataLoading(accounts)) return null;

  return (
    <div
      className="flex items-center gap-2.5 rounded-[10px] border border-primary/22 bg-primary/8 px-3.5 py-2.5 text-[0.875rem] text-white/[0.88]"
      role="status"
      aria-live="polite"
    >
      <span
        className="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-primary/25 border-t-primary"
        aria-hidden
      />
      <span>{comparisonLoadingMessage(accounts)}</span>
    </div>
  );
};

export default ComparisonLoadingBanner;
